var _a;
import { useShellShimReact } from '@office-start/shell-shim-service';
import { OfficeThemeMode, } from '@office-start/theming-types';
import { HarmonyThemeMode } from '@office-start/visual-types';
import { useEffect } from 'react';
var harmonyThemeModeToOfficeThemeMode = (_a = {},
    _a[HarmonyThemeMode.Contrast] = OfficeThemeMode.highContrast,
    _a[HarmonyThemeMode.Dark] = OfficeThemeMode.dark,
    _a[HarmonyThemeMode.Light] = OfficeThemeMode.default,
    _a[HarmonyThemeMode.System] = OfficeThemeMode.default,
    _a);
/**
 * Update the shell theme (mode) when visual data changes
 */
export var useUpdateVisualThemeMode = function (_a) {
    var entitlements = _a.entitlements, shellTheme = _a.shellTheme, visualThemeData = _a.visualThemeData, harmonyThemeData = _a.harmonyThemeData;
    var shellShim = useShellShimReact();
    useEffect(function () {
        // Do not update the shell header if the user is not a consumer user.
        if (!(entitlements === null || entitlements === void 0 ? void 0 : entitlements.isConsumerUser) || !harmonyThemeData || !shellShim) {
            return;
        }
        // Do nothing if modes are the same
        var visualThemeMode = harmonyThemeModeToOfficeThemeMode[visualThemeData.mode];
        if (visualThemeMode === (shellTheme === null || shellTheme === void 0 ? void 0 : shellTheme.mode)) {
            return;
        }
        // SetThemeOverrideData. This will cause a ThemeChange event for shell which
        // will update shellTheme in useShellTheme
        var IsDarkTheme = visualThemeMode === OfficeThemeMode.dark;
        shellShim.Theme.SetThemeOverrideData({
            IsDarkTheme: IsDarkTheme,
            isMicaEnabled: false,
            UserPersonalizationAllowed: !entitlements.UseTenantTheme,
            PreferOfficeTheme: entitlements.PreferOfficeTheme,
            UserThemeId: 'base',
            // This does not take into account app theme accent colors which are
            // present in app themes. This also does not work in v1
            UserThemePalette: IsDarkTheme
                ? harmonyThemeData.colors.DarkTheme
                : harmonyThemeData.colors,
        });
    }, [
        entitlements,
        harmonyThemeData,
        shellShim,
        shellTheme === null || shellTheme === void 0 ? void 0 : shellTheme.mode,
        visualThemeData.mode,
    ]);
};
//# sourceMappingURL=useUpdateVisualThemeMode.js.map